<template lang="pug">
  .component-selectize-driver
    selectize(
      v-if="options",
      :selectedValue="selectedValue" :options="options",
      value-field="id",
      :maxItems="maxItems" label-field="name",
      :items="items" :searchField="searchableFields",
      :optionTemplate="optionTemplate",
      :renderTemplate="renderTemplate",
      @itemAdded="optionSelected",
      @itemRemoved="optionRemoved",
      :allowEmptyOption="allowEmptyOption",
      placeholder="Policies")
</template>

<script>
  import Selectize from '../../../Selectize'
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'

  export default {
    name: 'SelectizePolicy',
    extends: BaseSelectize,
    components: {Selectize},
    data() {

      return {
        searchableFields: ['id', 'name']
      }
    },
    created() {
      KeplerBackofficeSdk.policies.list(1, -1).all((data) => {
        this.options = data.items
      })
    },
    methods: {
      optionTemplate(item, escape) {
        if (item.id) {
          return `<div><div><small>P${item.id}</small></div><div>${item.name}</div><div>${item.type}</div></div>`
        }
        return `<div><div>Select Policy</div></div>`
      },
      renderTemplate(item, escape) {
        if (item.id) {
          return `<div><div><small>P${item.id}</small></div><div>${item.name}</div></div>`
        }
        return `<div>Select Policy</div>`
      }
    },
    props: ['selectedValue']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizePolicy.vue?93520b1a